import { Component } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})

export class AppComponent {
	title = 'app';
	wrapperClass = '';
	panelClass = '';
	footerClass = '';

	constructor() {}

	ngOnInit() {
		if(sessionStorage.getItem('access_token_nv_admin')) {
			this.panelClass = 'main-panel';
			return true;
		} else {
			this.wrapperClass = 'wrapper-full-page';
			this.panelClass = 'main-panel large-panel';
			this.footerClass = 'footer-transparent';
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts